import axios from "axios";
import VueJwtDecode from "vue-jwt-decode";
import store from "../store";

const API_URL = process.env.VUE_APP_IP_ADDRESS + "/api/v1/auth/";
const config = {
  headers: {
    "content-type": "application/json",
    "x-source-user": "customer",
  },
};

class AuthService {
  googleLogin(user) {
    return axios
      .post(
        API_URL + "login/google",
        {
          emailAddress: user.email,
          name: user.name,
          avatarUrl: user.picture,
        },
        {
          headers: {
            "content-type": "application/json",
            "x-source-user": user.domain,
          },
        }
      )
      .then((response) => {
        console.log(response);
        var res = response.data;

        if (res.header.responseCode == 200) {
          if (res.body.token) {
            var decryptedRes = VueJwtDecode.decode(res.body.token);

            decryptedRes.expires = res.body.expires;

            var today = new Date();
            var tokenExpiry = new Date(0);
            tokenExpiry.setUTCSeconds(decryptedRes.expires);

            if (tokenExpiry > today) {
              window.localStorage.setItem(
                "token-" + user.domain + "-" + user.origin,
                JSON.stringify(decryptedRes)
              );
            }
          }
        }

        return res;
      });
  }
  login(user) {
    return axios
      .post(
        API_URL + "login",
        {
          emailAddress: user.email,
          password: user.password,
        },
        config
      )
      .then((response) => {
        var res = response.data;

        if (res.header.responseCode == 200) {
          if (res.body.token) {
            var decryptedRes = VueJwtDecode.decode(res.body.token);
            decryptedRes.token = res.body.token;
            decryptedRes.expires = res.body.expires;

            var today = new Date();
            var tokenExpiry = new Date(0);
            tokenExpiry.setUTCSeconds(decryptedRes.expires);

            if (tokenExpiry > today) {
              window.localStorage.setItem(
                "token",
                JSON.stringify(decryptedRes)
              );
            }
          }
        }

        return res;
      });
  }

  logout(user) {
    // Clear all common tokens and state
    window.localStorage.removeItem("userId");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("loggedIn");

    // Clear user-specific tokens if user object is provided
    if (user && user.domain && user.origin) {
      window.localStorage.removeItem(
        "token-" + user.domain + "-" + user.origin
      );
    } else {
      // If user object not provided, try to clear all possible token combinations
      const domains = ["business", "customer"];
      const origins = ["customer", "admin"];

      domains.forEach((domain) => {
        origins.forEach((origin) => {
          window.localStorage.removeItem("token-" + domain + "-" + origin);
        });
      });
    }

    // Clear cart data
    window.localStorage.removeItem("cart");
    window.localStorage.removeItem("totalCartItems");
    window.localStorage.removeItem("totalCartPrice");

    // Update store state if available
    if (store && typeof store.commit === "function") {
      try {
        store.commit("updateLoginStatus", false);
        store.commit("dropUserInfo");
      } catch (error) {
        console.error("Error updating store during logout:", error);
      }
    }
  }

  register(user) {
    return axios
      .post(
        API_URL + "register",
        {
          emailAddress: user.email,
          contactNumber: user.contactNumber,
          firstName: user.firstName,
          lastName: user.lastName,
          activationLink: user.activationLink,
        },
        {
          headers: {
            "content-type": "application/json",
            "x-source-user": user.domain,
          },
        }
      )
      .then((response) => {
        console.log(response);
        var res = response.data;

        return res;
      });
  }

  resetPassword(user) {
    return axios
      .post(
        API_URL + "reset-password",
        {
          emailAddress: user.email,

          passwordResetLink: user.passwordResetLink,
        },
        {
          headers: {
            "content-type": "application/json",
            "x-source-user": user.domain,
          },
        }
      )
      .then((response) => {
        var res = response.data;

        return res;
      });
  }
}

export default new AuthService();
